import { APIROOT } from './configs';

export const r2_updateData = (config) => {
  const {
    uri,
    dataBlob,
    cancelEdit,
    setForceUpdate,
    navigateBack,
    path,
    logout,
    enqNotification,
    updateMessage,
    type,
    errorMessage,
    state,
  } = config;
  // const DataBlob = dataBlob;

  //Get JWT from storage
  let JWT = localStorage.getItem('JWT_Key');
  //Set default Headers
  let headers = {
    'content-type': 'application/JSON',
  };
  //Set JWT in header if available
  if (JWT) {
    headers['x-api-key'] = JWT;
  }
  let body = {};

  body = dataBlob;
  // body = { constant: DataBlob };
  const request = new Request(`${APIROOT}/api${uri}`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });

  fetch(request)
    .then((response) => {
      if (response.status === 200) {
        return response.text();
      } else {
        throw new Error(`Failed to save information`);
      }
    })
    .then((data) => {
      let parsed = JSON.parse(data);
      if (parsed.success === true) {
        setForceUpdate((val) => val + 1);
        //Update JWT if required
        if (parsed.JWT) {
          localStorage.setItem('JWT_Key', parsed.JWT);
        }
        enqNotification(updateMessage, 'success');
        cancelEdit();
        navigateBack(`${path}`, { replace: true, state: state });
      } else {
        //Force logout
        if (parsed.message === 'Please login') {
          logout(() => {
            enqNotification('Session Expired', 'warning');
          });
        } else {
          enqNotification(
            // checkUpdateErrorString(type, parsed.message),
            checkUpdateErrorString(type, parsed.message),
            'error'
          );
        }
      }
    })
    .catch((error) => {
      console.log(error);
      enqNotification(
        typeof error == 'string' ? error : 'Hook Connection Error',
        'error'
      );
    });
};

export function r2_noHeaderTableUpdate(config, filterReq) {
  const {
    setDataFunc, //Function to set data returned
    pageNum, //Page requested
    setLoadingFunc, //Function to set loading on datagrid (set bool)
    pagesize, //Number of rows on page
    sorting, //Sorting model
    filtering, //Filtering model
    setRows, //Set total rows function
    resource, //URI of Resource
    showNotification, //Function to enque notification
    logout, //Function to log user out in case of expired JWT

    action,
    fullFilters,
    rangeFilters,
    //Report params
    requestValue,
    startDate,
    endDate,
    userId,
  } = config;
  setDataFunc([]);
  setLoadingFunc(true);
  let payload;
  let blobReq = filterReq;

  switch (blobReq) {
    case 'customersv2':
      payload = {
        pagereq: {
          filter: {
            sort: sorting,
            quickfilter: filtering[0],
            fullfilter: fullFilters,
          },
          page: pageNum,
          rowsperpage: pagesize,
        },
      };
      break;
    case 'r2_consumables':
      payload = {
        pagereq: {
          filter: {
            sort: sorting,
            quickfilter: filtering[0],
            fullfilter: fullFilters,
          },
          page: pageNum,
          rowsperpage: pagesize,
        },
      };
      break;
    case 'r2_constants':
      payload = {
        pagereq: {
          filter: {
            sort: sorting,
            quickfilter: filtering[0],
            fullfilter: fullFilters,
          },
          page: pageNum,
          rowsperpage: pagesize,
        },
      };
      break;
    case 'serial':
      payload = {
        pagereq: {
          filter: {
            sort: sorting,
            quickfilter: filtering[0],
            fullfilter: fullFilters,
            rangefilter: rangeFilters,
          },
          page: pageNum,
          rowsperpage: pagesize,
        },
      };
      break;
    case 'r2_users':
      payload = {
        pagereq: {
          filter: {
            sort: sorting,
            quickfilter: filtering[0],
            fullfilter: fullFilters,
          },
          page: pageNum,
          rowsperpage: pagesize,
        },
      };
      break;
    case 'r2_timelines':
      payload = {
        pagereq: {
          filter: {
            sort: sorting,
            quickfilter: filtering[0],
            fullfilter: fullFilters,
            rangefilter: rangeFilters,
          },
          page: pageNum,
          rowsperpage: pagesize,
        },
      };
      break;

    case 'actions':
      payload = { action };
      break;
    case 'clocked_in':
      payload = { request: 'technician_clocked_in' };
      break;
    case 'payroll_report':
      payload = {
        request: 'payroll_report',
        params: {
          start_date: startDate,
          stop_date: endDate,
          user: userId,
        },
      };
      break;
    case 'install_analysis_report':
      payload = {
        request: 'install_analysis_report',
        params: {
          start_date: startDate,
          stop_date: endDate,
        },
      };
      break;
    case 'spare_usage_report':
      payload = {
        request: 'spare_usage_report',
        params: {
          start_date: startDate,
          stop_date: endDate,
          user: userId,
        },
      };
      break;
    case 'repair_bulk_data_report':
      payload = {
        request: 'repair_bulk_data_report',
        params: {
          start_date: startDate,
          stop_date: endDate,
        },
      };
      break;
    case 'ticketing_report':
      payload = {
        request: 'ticketing_report',
        params: {
          start_date: startDate,
          stop_date: endDate,
        },
      };
      break;

    default:
      payload = {
        pagereq: {
          filter: {
            sort: sorting,
            quickfilter: filtering[0],
          },
          page: pageNum,
          rowsperpage: pagesize,
        },
      };
      break;
  }

  let JWT = localStorage.getItem('JWT_Key');

  //Set default Headers
  let headers = {
    'content-type': 'application/JSON',
  };
  //Set JWT in header if available
  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  const request = new Request(`${APIROOT}${resource}`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(payload),
  });
  // console.log(JSON.stringify(payload, null, '\t'));
  fetch(request)
    .then((data) => {
      if (data.status === 200) {
        return data.text();
      } else {
        throw new Error(`Invalid Response`);
      }
    })
    .then((data) => {
      var parsed = JSON.parse(data);
      if (parsed.success === true) {
        setRows(parsed.data.totalrows ? parsed.data.totalrows : 0);
        setDataFunc(parsed.data.value);
        // setColumnFunc(parsed.data.value.columns);
        if (parsed.JWT) {
          localStorage.setItem('JWT_Key', parsed.JWT);
        }
      } else {
        if (parsed.message === 'Please login') {
          logout(() => {
            showNotification('Session Expired', 'warning');
          });
        } else {
          showNotification(parsed.message, 'error');
        }
      }
      setLoadingFunc(false);
    })
    .catch((error) => {
      console.log(error);
      setLoadingFunc(false);
      showNotification(
        typeof error == 'string' ? error : 'Connection Error',
        'error'
      );
    });
}

export function r2_unfilteredList(config) {
  const {
    setDataFunc, //Function to set data returned
    resource, //URI of Resource
    showNotification, //Function to enque notification
    logout, //Function to log user out in case of expired JWT
    payloadBlob,
  } = config;
  setDataFunc([]);
  let payload;

  // payload = {
  //   pagereq: {},
  // };
  payload = payloadBlob;

  let JWT = localStorage.getItem('JWT_Key');

  //Set default Headers
  let headers = {
    'content-type': 'application/JSON',
  };
  //Set JWT in header if available
  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  const request = new Request(`${APIROOT}${resource}`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(payload),
  });
  // console.log(JSON.stringify(payload, null, '\t'));
  fetch(request)
    .then((data) => {
      if (data.status === 200) {
        return data.text();
      } else {
        throw new Error(`Invalid Response`);
      }
    })
    .then((data) => {
      var parsed = JSON.parse(data);
      if (parsed.success === true) {
        setDataFunc(parsed.data.value);
        if (parsed.JWT) {
          localStorage.setItem('JWT_Key', parsed.JWT);
        }
      } else {
        if (parsed.message === 'Please login') {
          logout(() => {
            showNotification('Session Expired', 'warning');
          });
        } else {
          showNotification(parsed.message, 'error');
        }
      }
    })
    .catch((error) => {
      console.log(error);
      showNotification(
        typeof error == 'string' ? error : 'Connection Error',
        'error'
      );
    });
}

export function r2_CheckUserName(config) {
  const {
    showNotification, //Function to enque notification
    logout, //Function to log user out in case of expired JWT
    username,
  } = config;
  let payload = {
    pagereq: {
      filter: {
        fullfilter: {
          field: 'username',
          search: username,
          strict: true,
        },
      },
    },
  };
  let JWT = localStorage.getItem('JWT_Key');
  //Set default Headers
  let headers = {
    'content-type': 'application/JSON',
  };
  //Set JWT in header if available
  if (JWT) {
    headers['x-api-key'] = JWT;
  }
  const request = new Request(`${APIROOT}/api/r2_users`, {
    method: 'post',
    headers: headers,
    body: JSON.stringify(payload),
  });

  // console.log(JSON.stringify(payload, null, '\t'));
  fetch(request)
    .then((data) => {
      if (data.status === 200) {
        return data.text();
      } else {
        throw new Error(`Invalid Response`);
      }
    })
    .then((data) => {
      var parsed = JSON.parse(data);

      if (parsed.success === true) {
        if (parsed.data.totalrows !== 0) {
          showNotification(
            'A user with this username already exists',
            'warning'
          );
          // return 'alreadyExist';
        } else {
          showNotification('Saving user details', 'success');
          // return 'dontExist';
        }
      } else {
        if (parsed.message === 'Please login') {
          logout(() => {
            showNotification('Session Expired', 'warning');
          });
        } else {
          showNotification(parsed.message, 'error');
        }
      }
    })
    .catch((error) => {
      showNotification(
        typeof error == 'string' ? error : 'A big Error',
        'error'
      );
    });
}
export function r2_CheckCabinet(config) {
  const {
    showNotification, //Function to enque notification
    logout, //Function to log user out in case of expired JWT
    serialNo,
    setDataFunc,
  } = config;
  setDataFunc(0);
  let payload = {
    pagereq: {
      filter: {
        fullfilter: [
          {
            field: 'serial_number',
            search: serialNo,
            strict: true,
          },
        ],
      },
    },
  };
  let JWT = localStorage.getItem('JWT_Key');
  //Set default Headers
  let headers = {
    'content-type': 'application/JSON',
  };
  //Set JWT in header if available
  if (JWT) {
    headers['x-api-key'] = JWT;
  }
  const request = new Request(`${APIROOT}/api/serialnumbers`, {
    method: 'post',
    headers: headers,
    body: JSON.stringify(payload),
  });

  // console.log(JSON.stringify(payload, null, '\t'));
  fetch(request)
    .then((data) => {
      if (data.status === 200) {
        return data.text();
      } else {
        throw new Error(`Invalid Response`);
      }
    })
    .then((data) => {
      var parsed = JSON.parse(data);

      if (parsed.success === true) {
        setDataFunc(parsed.data.totalrows);
      } else {
        if (parsed.message === 'Please login') {
          logout(() => {
            showNotification('Session Expired', 'warning');
          });
        } else {
          showNotification(parsed.message, 'error');
        }
      }
    })
    .catch((error) => {
      showNotification(
        typeof error == 'string' ? error : 'A big Error',
        'error'
      );
    });
}

// -- HELPER FUNCTIONS -- \\

const checkUpdateErrorString = (type, errorString) => {
  let returnString = 'check string';

  if (type === 'user' && errorString === 'Field(s) failed to validate') {
    returnString =
      "The username is already in use. Usernames can't be duplicated";
  } else if (
    type === 'consumable' &&
    errorString === 'Field(s) failed to validate'
  ) {
    returnString =
      "The item code is already in use. item codes can't be duplicated";
  } else if (
    type === 'constant' &&
    errorString === 'Field(s) failed to validate'
  ) {
    returnString =
      "That constant is already in use. Constants can't be duplicated";
  } else if (
    type === 'timeAndAttendance' &&
    errorString === 'No start / stop override time present'
  ) {
    returnString =
      "No Changes made. Select new values before saving or click 'CANCEL' to exit ";
  } else {
    returnString = errorString;
  }
  return returnString;
};

// [
//   {
//     field: 'start_time',
//     start: rangeFilterDateStart,
//     stop: rangeFilterDateEnd,
//   },
//   {
//     field: 'stop_time',
//     start: rangeFilterDateStart,
//     stop: null, //rangeFilterDateEnd -- To be tested
//   },
// ],
